(function(gsap) {
  const currentSectionID = document.currentScript.dataset.sectionID;
  const $section = document.querySelector(`.${currentSectionID}`);

  const helpers = function() {
    const getRandom = function(range) {
      return Math.random() * (range[1] - range[0]) + range[0];
    };

    const hasOverlap = function($container, positions, newPosition, dimensions) {
      let foundOverlap = false;

      positions.forEach(function(oldPosition) {
        if (oldPosition) {
          const $containerWidth = $container.offsetWidth;
          const $containerHeight = $container.offsetHeight;

          const newX = $containerWidth * (newPosition[0] * 0.01);
          const newY = $containerHeight * (newPosition[1] * 0.01);
          const oldX = $containerWidth * (oldPosition[0] * 0.01);
          const oldY = $containerHeight * (oldPosition[1] * 0.01);

          const clearance = Math.sqrt(Math.pow(oldX - newX, 2) + Math.pow(oldY - newY, 2));
          const minDistance = Math.sqrt(Math.pow(dimensions[0], 2) + Math.pow(dimensions[1], 2));

          if (clearance < minDistance) {
            foundOverlap = true;
          }
        }
      });

      return foundOverlap;
    };

    const isMobileView = function() {
      return window.innerWidth < 576;
    };

    return {
      getRandom,
      hasOverlap,
      isMobileView,
    };
  }();

  // star animation
  const $starField = $section.querySelector('.stars');
  if (gsap && $starField) {
    const starUrl = $starField.dataset.star;
    const starWidth = $starField.dataset.starW;
    const starHeight = $starField.dataset.starH;
    const starAmount = parseInt($starField.dataset.starAmount);
    const starPositions = [...new Array(starAmount)];
    let isLeftStar = true;
    let isTopStar = false;

    const setStarScaleAndPosition = function($el, starIndex) {
      let leftRange;
      let topRange;
      let starScale;
      let starScaledWidth;
      let starScaledHeight;
      let starLeft;
      let starTop;

      if (helpers.isMobileView()) {
        leftRange = isLeftStar ? [20, 30] : [75, 80];
        topRange = isTopStar ? [20, 30] : [60, 65];
        starScale = helpers.getRandom([0.35, 0.55]);
      } else {
        leftRange = isLeftStar ? [25, 30] : [75, 80];
        topRange = isTopStar ? [20, 25] : [60, 70];
        starScale = helpers.getRandom([0.5, 0.85]);
      }

      starScaledWidth = Math.floor(starWidth * starScale);
      starScaledHeight = Math.floor(starHeight * starScale);
      starLeft = helpers.getRandom(leftRange);
      starTop = helpers.getRandom(topRange);

      let hasOverlap = true;
      // escape hatch, because of designs, stars stay relatively in the same positions
      // so chances of getting overlaps are pretty high but at least we're trying
      // our best here to keep the stars from overlapping on top of each other
      let overlapChecks = 0;
      do {
        hasOverlap = helpers.hasOverlap($starField, starPositions, [starLeft, starTop], [starScaledWidth, starScaledHeight]);

        if (hasOverlap) {
          starLeft = helpers.getRandom(leftRange);
          starTop = helpers.getRandom(topRange);
        }

        overlapChecks++;
      } while (hasOverlap && overlapChecks < 50)

      starPositions[starIndex] = [starLeft, starTop];
      $el.style.setProperty('top', `${starTop}%`);
      $el.style.setProperty('left', `${starLeft}%`);
      $el.style.setProperty('width', `${starScaledWidth}px`);
      $el.style.setProperty('height',  `${starScaledHeight}px`);
      $el.style.setProperty('background-size', `${starScaledWidth}px ${starScaledHeight}px`)
      isLeftStar = !isLeftStar;
      isTopStar = !isTopStar;
    };

    starPositions.forEach(function(_, starIndex) {
      const $starEl = document.createElement('div');
      $starEl.classList.add('star-child');
      $starEl.style.setProperty('background-image', `url('${starUrl}')`);

      // we wrap this gsap animation in a function in order to be able to set a
      // new random scale, position, duration, and delay each time the onComplete is called
      const setStarAnimation = function() {
        setStarScaleAndPosition($starEl, starIndex);

        window.gsap.fromTo($starEl, {
          autoAlpha: 0,
          scale: 0.16,
          xPercent: -50,
          yPercent: -50,
        }, {
          autoAlpha: 1,
          scale: 1,
          duration: helpers.getRandom([0.8, 1.6]),
          delay: helpers.getRandom([0, 0.5]),
          repeat: 1,
          y: 10,
          yoyo: true,
          transformOrigin: 'center',
          onComplete: setStarAnimation,
        }).repeatDelay(helpers.getRandom([0.4, 1.2]));
      }
      setStarAnimation();

      $starField.appendChild($starEl);
    });
  }

})(window.gsap);
